import { DataBean } from "../DataBean";

export class LoanTimeTerm extends DataBean {
  public async getLoanTimeTermCatalog(
    idLoanTimeTerm: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getLoanTimeTermCatalog_Number",
      [idLoanTimeTerm]
    );
  }

  public async deleteLoanTimeTerm(idLoanTimeTerm: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "void_deleteLoanTimeTerm_Number",
      [idLoanTimeTerm]
    );
  }

  public async updateLoanTimeTerm(bean: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.loans.LoanTimeTerm_updateLoanTimeTerm_com.quickdataerp.bean.loans.LoanTimeTerm",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.quickdataerp.bean.loans.LoanTimeTerm",
        },
      ]
    );
  }
}
